/* Fransk katalog for locale-invoice-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'control.expand': 'Agrandir le chat',
  'control.collapse': 'Réduire le chat',
  'control.proposalIncomplete': 'La proposition de facture est incomplète. Les lignes et les détails ne sont pas renseignés. Indiquez ce qui manque ou complétez le formulaire.',
  'control.reloadRequired': 'Le mode facture a été mis à jour. Rechargez la page avant de continuer. Aucun champ n\'a été modifié.',
  'control.fieldsApplied': 'Le client et les lignes de facture ont été renseignés dans le formulaire. Le brouillon n\'est pas enregistré.',
  'control.customerApplied': 'Le client est sélectionné dans le formulaire de facture.',
  'control.onepageApplied': 'L\'affichage est passé à « tout sur une page ».',
  'control.stepsApplied': 'L\'affichage est passé à la saisie étape par étape.',
  'control.editorOpened': 'La page de nouvelle vente est ouverte.',
  'control.listOpened': 'La liste des factures est ouverte.',
  'control.saveReady': 'Le brouillon peut être enregistré dès que vous me le demandez.',
  'control.noChange': 'Aucun champ n\'a été modifié. Décrivez ce que vous souhaitez saisir sur la facture.',
  'control.title': 'SuperPlumma fait le travail',
  'control.scope': 'Que souhaitez-vous faire ?',
  'control.you': 'Vous',
  'control.input': 'Que souhaitez-vous faire ?',
  'control.run': 'Exécuter',
  'control.speak': 'Voix',
  'control.stopMic': 'Annuler la saisie vocale',
  'control.stop': 'Arrêter',
  'control.minimize': 'Réduire l\'assistant',
  'control.newChat': 'Nouvelle conversation',
  'control.working': 'Plumme travaille …',
  'control.saved': 'Le brouillon est enregistré. La facture n\'a pas été envoyée.',
  'control.reviewHelp': 'Vérifiez la facture dans l\'aperçu. Utilisez « Créer la facture » et les options d\'envoi habituelles pour terminer.',
  'control.save': 'Enregistrer le brouillon',
  'control.listening': 'Écoute …',
  'control.voiceUnsupported': 'Ce navigateur ne prend pas en charge la voix ici. Vous pouvez toujours écrire.',
  'control.voiceFailed': 'La voix n\'a pas pu être reconnue. Vérifiez l\'accès au microphone ou écrivez votre message.',
  'control.editorUnavailable': 'L\'éditeur de facture n\'est pas disponible. Ouvrez la facture et réessayez.',
  'control.editorChanged': 'La facture a été modifiée pendant que je travaillais. Redemandez la modification pour que j\'utilise les champs les plus récents.',
  'control.invoiceOnly': 'Ce mode prend en charge les factures. Utilisez l\'assistant habituel pour les autres tâches.',
  'control.agentUnavailable': 'Le mode facture nécessite le nouveau service d\'assistant, qui n\'est pas disponible pour le moment. Aucune modification n\'a été appliquée.',
  'control.advancedInvoice': 'Cette facture comporte des détails qui doivent être modifiés dans le formulaire dans cette première version. Aucun champ n\'a été modifié.',
  'control.customerRequired': 'Choisissez un client existant ou créez d\'abord le client dans le registre des clients.',
  'control.incomplete': 'Choisissez un client et ajoutez une ligne de facture avant d\'enregistrer.',
  'control.saveBeforeLeaving': 'Enregistrez le brouillon avant d\'ouvrir la liste des factures pour conserver vos modifications.',
  'control.failed': 'La tâche n\'a pas pu être terminée. Réessayez.',
  'pageControl.working': 'Travail dans la page ...',
  'pageControl.done.applied': 'Les champs ont été mis à jour dans la page habituelle.',
  'pageControl.done.saved': 'L\'action a été effectuée via le flux d\'enregistrement habituel de la page.',
});
